import React, { Component } from 'react';
import PropTypes from 'prop-types';
import style from './style/badge.scss';

class Badge extends Component {
    render() {
        const { classes } = this.props;

        return (<div className={ `${style.badge} ${classes.root}` }>
            <figure className={ classes.figure } />
        </div>);
    }
}

export default Badge;

Badge.propTypes = {
    classes: PropTypes.object
};

Badge.defaultProps = {
    classes: {
        root: '',
        figure: ''
    }
};
